import { SyntheticEvent, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router'

import { SetupWorkspaceRoutes } from 'app/application/types'
import { ArrowRightIcon } from 'app/common/presentation/icons'
import { useUser } from 'app/user/application'

import { Button, Input } from 'components'

import { AccessPage } from '../AccessPage'
import accessStyles from '../AccessPage/AccessPage.module.scss'

const ResetPassword = () => {
  const navigate = useNavigate()
  const { t } = useTranslation('user')

  const { triggerPasswordReset } = useUser()

  const [email, setEmail] = useState('')
  const [error, setError] = useState('')

  const handlePasswordReset = (e: SyntheticEvent) => {
    e.preventDefault()

    void triggerPasswordReset(email).then((result) => {
      if (result.ok) {
        void navigate(SetupWorkspaceRoutes.CheckInbox, {
          state: { email },
        })
      } else {
        setError(result.val.message)
      }
    })
  }

  return (
    <AccessPage>
      <div>
        <h1>{t('resetPassword.title')}</h1>
        <div className={accessStyles.message}>{t('resetPassword.description')}</div>
      </div>
      <form onSubmit={handlePasswordReset}>
        <Input
          autoComplete="username"
          autoFocus
          error={error}
          label={t('resetPassword.email')}
          mandatory
          onChange={setEmail}
          placeholder={t('resetPassword.placeholder')}
          value={email}
        />
        <Button disabled={!email} type="submit" rightIcon={<ArrowRightIcon />}>
          {t('resetPassword.sendResetLink')}
        </Button>
      </form>
    </AccessPage>
  )
}

export default ResetPassword
